export default __webpack_public_path__ + "static/media/automation.6935c5d2.webp";